import { useMemo, useState } from "react";
import { useLists } from "@/api/list";
import { List } from "@/api/types";
import useActiveGym from "@/ui/hooks/active-gym";

interface Option {
  label: string;
  value: string;
}

export function useFetchListsAsOptions(type?: "static" | "dynamic"): {
  options: Option[];
  isLoading: boolean;
} {
  const { gym } = useActiveGym();
  const params: { gym?: string; type?: "static" | "dynamic" } = { gym: gym?.id };
  if (type) params.type = type;
  const { data: lists, isLoading } = useLists(params);
  const [options, setOptions] = useState<Option[]>([]);

  useMemo(() => {
    async function fetchOptions() {
      if (!lists) return;
      setOptions(
        lists?.map((list: List) => {
          return {
            label: list.name,
            value: list.id,
          };
        }),
      );
    }
    fetchOptions();
  }, [lists]);

  return { options, isLoading };
}
